import styled from 'styled-components';
import GasStationHistorySearchBoard from '../../components/board/GasStationHistorySearchBoard';

function GasStationHistory() {
  return (
    <Wrapper>
      <GasStationHistorySearchBoard />
    </Wrapper>
  );
}

export default GasStationHistory;

const Wrapper = styled.div``;
